import React from 'react'
import style from './e3dVoip.css'

const E3DVoip: React.FC = () => (
  <div className={style.e3dVoipContainer}>
    <e3d-voip />
  </div>
)

export default E3DVoip
